import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FAQSection />
        <CarouselSection />
        <IndexSection />
        <CommentsSection />
        <AboutSection />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <TopicsSection />
        <AppSection />
        <RankingSection />
        <FeaturesSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}